import AgencyMapAnimation from '../../../../utils/AgencyMapAnimation';

AgencyMapAnimation.init();
